<template>
  <div class="proj-toolbox-area">
    <b-row>
      <b-col md="12">
        <h4 v-text="$t('menu.user') + ' 操作 Logs'"></h4>
        <h6 class="text-muted">User ID = {{ userID }}</h6>
      </b-col>
      <b-col md="6">
        <div class="text-center">
          <DatePickerTool
            :timezone="timezone"
            :no_bounding="true"
            :shortcut_no_shift="true"
            :default_query="default_dateRange"
            @date-range="dateRange = $event"
          ></DatePickerTool>

          <!-- Show -->
          <b-button
            id="button-show"
            class="btn btn-success px-4 btn-upload"
            @click="setQueryRange()"
            :disabled="loading_showInfo || checkDisabled"
          >
            <i class="fa fa-search block-text"></i>{{ $t("menu.show") }}
          </b-button>
        </div>
      </b-col>
      <b-col md="6">
        <SearchTool
          :list_data="list_logs"
          :search_key="['type', 'log_time']"
          :search_tooltip="''"
          @search-result="search_result = $event"
        ></SearchTool>
      </b-col>
    </b-row>

    <div class="edit-area" v-if="search_result && search_result.length > 0">

      <!-- 顯示時間區段內的操作統計圖表 -->
      <div>
        <LineChartSimple
          v-if="logs_week_summary"
          :chartID="`week-summary-chart`"
          :chartTall="true"
          :title="undefined"
          :xData="logs_week_summary.log_time"
          :yData="logs_week_summary.values"
          :xAxisName="'week first date'"
          :yAxisName="'times'"
          :xAxisUseDateFormat="true"
          :showToolbox="true"
        ></LineChartSimple>
      </div>

      <b-row align-h="end">
        <b-col md="4">
          <b-form-group
            label-cols-md="4"
            :label="$t('menu.per_page')"
            class="mb-0"
          >
            <b-form-select
              v-model="perPage"
              :options="pageOptions"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <div class="list-table-result scroll-style-gray overflow-x">
        <b-table
          hover
          small
          responsive="xl"
          :fields="table_fields"
          :items="table_items"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <!-- A virtual column -->
          <template #cell(page)="row">
            <div v-if="row.item.detail">{{ row.item.detail.page }}</div>
          </template>
          <template #cell(action)="row">
            <div v-if="row.item.detail">{{ row.item.detail.action }}</div>
          </template>

          <template #cell(details)="row">
            <b-button
              size="sm"
              @click="row.toggleDetails"
              class="mr-2 btn-warning"
            >
              {{ row.detailsShowing ? "Hide" : "Show" }}
            </b-button>
          </template>
          <template #row-details="row">
            <div
              v-for="(detail_item, detail_key, idx_di) in row.item.detail"
              :key="idx_di"
            >
              <div v-if="typeof detail_item == 'array'">
                <div class="detail-key">
                  <i class="fa fa-paw block-title"></i>{{ detail_key }}：
                </div>
                <div class="detail-item">{{ detail_item }}</div>
              </div>
              <div v-else-if="typeof detail_item == 'object'">
                <div class="detail-key">
                  <i class="fa fa-paw block-title"></i>{{ detail_key }}：
                </div>
                <div class="proj-toolbox-area detail-item">
                  <div
                    v-for="(dd_item, dd_key, idx_ddi) in detail_item"
                    :key="idx_ddi"
                  >
                    <div class="detail-title">- {{ dd_key }}：</div>
                    <div class="detail-item">{{ dd_item }}</div>

                    <!-- 加上超連結 -->
                    <div v-if="dd_key == 'project ID'" class="detail-title">
                      <i
                        class="fa fa-external-link-square clickable"
                        @click="
                          goToPage(
                            'Project Summary',
                            { projectID: dd_item },
                            true
                          )
                        "
                      ></i>
                    </div>
                    <div
                      v-if="
                        dd_key == 'cropperiod ID' &&
                        detail_item['project ID'] != undefined
                      "
                      class="detail-title"
                    >
                      <i
                        class="fa fa-external-link-square clickable"
                        @click="
                          goToPage(
                            'Cropperiod',
                            {
                              projectID: detail_item['project ID'],
                              cropperiodID: dd_item,
                            },
                            true
                          )
                        "
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="detail-key">
                  <i class="fa fa-paw block-title"></i>{{ detail_key }}：
                </div>
                <div class="detail-item">{{ detail_item }}</div>
              </div>
            </div>

            <br />
          </template>
        </b-table>

        <!-- 分頁 -->
        <div v-if="perPage">
          <b-pagination
            v-model="currentPage"
            :total-rows="table_items.length"
            :per-page="perPage"
          ></b-pagination>
        </div>
      </div>
    </div>
    <div v-else>
      <NoData></NoData>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import AgriLoading from "@/views/components/AgriLoading";
import SearchTool from "@/views/components/SearchTool";
import NoData from "@/views/components/NoData";
import DatePickerTool from "@/views/components/DatePickerTool";
import LineChartSimple from "@/views/echarts/LineChart_Simple";

export default {
  components: {
    AgriLoading,
    SearchTool,
    NoData,
    DatePickerTool,
      LineChartSimple,
  },
  props: {
    userID: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      loading_showInfo: false,
      timezone: "Asia/Taipei",
      default_dateRange: [undefined, undefined],
      dateRange: undefined,
      list_logs: [],
      search_result: [],

      loading_week_summary: false,
      logs_week_summary: undefined,

      // table
      table_items: [],
      currentPage: 1,
      perPage: 50,
      pageOptions: [
        { value: 10, text: 10 },
        { value: 20, text: 20 },
        { vlaue: 50, text: 50 },
        { value: 100, text: 100 },
        { value: undefined, text: "all" },
      ],
    };
  },
  mounted() {
    this.timezone = this.$tools.date.getTimezoneNow();

    // 未設定的話，預設自動先取得 6+1 天前的資料
    this.getDateRange(-90);
    this.setQueryRange();
  },
  computed: {
    ...mapState({}),

    // Download Button Check State
    checkDisabled() {
      if (this.userID == undefined) return true;
      if (this.dateRange == undefined) return true;
      if (this.dateRange.start_time == undefined) return true;
      if (this.dateRange.end_time == undefined) return true;

      return false;
    },

    table_fields() {
      return [
        { key: "idx", sortable: true, label: undefined },
        { key: "type", sortable: true, label: this.$t("menu.type") },
        { key: "log_time", sortable: true, label: "操作時間" },
        { key: "page", sortable: true, label: "操作頁面" },
        { key: "action", sortable: true, label: "Action" },
        { key: "ip_address", sortable: true, label: "IP Address" },
        { key: "details", sortable: false, label: this.$t("menu.detail") },
      ];
    },
  },
  watch: {
    search_result(val, oldVal) {
      if (val) {
        this.arrangeTableData();
      }
    },
  },
  methods: {
    goToPage: function (name, params = {}, openNewTab = false) {
      this.$tools.ui.goToPage(this.$router, name, params, openNewTab);
    },

    getDateRange(_Day_shift = -6, _End_Day_shift = 0) {
      // 取得前 { _Day_shift + 1 } 天日期
      let _date_today = this.$tools.date.getDateNow(
        this.timezone,
        "YYYY-MM-DD 23:59"
      );
      let _dateNow = this.$tools.date.getDateShift(
        _date_today,
        _End_Day_shift,
        "days"
      ); // 取前一天資料
      let _dateStart = this.$tools.date.getDateShift(
        _dateNow,
        _Day_shift,
        "days",
        "YYYY-MM-DD 00:00"
      );

      this.default_dateRange = [_dateStart, _dateNow];
      this.dateRange = {
        start_time: _dateStart,
        end_time: _dateNow,
      };
    },

    setQueryRange() {
      this.getData_Records();
      this.getData_WeekSummary();
    },

    getData_WeekSummary() {
      this.loading_week_summary = true;
      this.logs_week_summary = undefined;

      let _start_time = this.$tools.date.dataTimeZone_to_UTC(
        this.dateRange.start_time,
        this.timezone
      );
      let _end_time = this.$tools.date.dataTimeZone_to_UTC(
        this.dateRange.end_time,
        this.timezone
      );

      const options = {
        method: "GET",
        url: this.$config.getAPI_URL("Get_OPLogs_Week_Summary") + `?user_ids=${ this.userID }&start_time=${ _start_time }&end_time=${ _end_time }`,
      };
      this.$http(options)
        .then((res) => {
          this.loading_week_summary = false;
            this.logs_week_summary = res.data;
        })
        .catch((err) => {
          this.loading_week_summary = false;
        });
    },

    getData_Records() {
      if (this.userID != undefined) {
        this.loading_showInfo = true;
        this.list_logs = [];

        let _start_time = this.$tools.date.dataTimeZone_to_UTC(
          this.dateRange.start_time,
          this.timezone
        );
        let _end_time = this.$tools.date.dataTimeZone_to_UTC(
          this.dateRange.end_time,
          this.timezone
        );

        const options = {
          method: "GET",
          url: this.$config.getAPI_URL("Get_User_OPLogs", {
            userID: this.userID,
            start_time: _start_time,
            end_time: _end_time,
          }),
        };
        this.$http(options)
          .then((res) => {
            this.loading_showInfo = false;

            let _all_logs = res.data.user_log.slice();
            _all_logs.forEach((_log) => {
              _log.log_time = this.$tools.date.dateTimeZone(
                _log.log_time,
                this.timezone,
                "YYYY-MM-DD HH:mm:ss"
              );
            });
            this.list_logs = _all_logs;
          })
          .catch((err) => {
            this.loading_showInfo = false;
          });
      }
    },

    arrangeTableData() {
      let _items = [];
      this.search_result.forEach((_data, _idx) => {
        let _new_data = this.$tools.data.deepCopy_object(_data); // 複製一份

        _new_data["idx"] = _idx + 1;

        _items.push(_new_data);
      });
      this.table_items = _items.reverse();
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-area {
  padding: 10px 15px;
}

.detail-key {
  display: inline-block;
  margin-left: 10px;
  color: #257d57;
}
.detail-title {
  display: inline-block;
  margin-left: 10px;
  color: #0086b3;
}
.detail-item {
  display: inline-block;
  margin-left: 10px;
}
</style>
